/**
 * MSAL (Microsoft Authentication Library) client-side plugin
 * Initializes Microsoft Graph authentication for browser environment
 */
export default defineNuxtPlugin(() => {
  // Only run on client side
  if (process.server) return
  
  // Plugin runs on client-side initialization
  // The actual MSAL initialization is handled in the useGraph composable
  // to ensure proper timing and error handling
  
  console.log('MSAL plugin loaded - Microsoft Graph authentication available')
})
